import { createApp } from 'vue';
import Cr3ToPngConverter from '../Components/Cr3ToPngConverter.vue';

const root = document.getElementById('cr3-to-png-converter');
if (root) {
  createApp(Cr3ToPngConverter).mount('#cr3-to-png-converter');
}
